import { render, staticRenderFns } from "./StuCZManage.vue?vue&type=template&id=d5c1ef48&scoped=true&"
import script from "./stuczmanage.js?vue&type=script&lang=js&"
export * from "./stuczmanage.js?vue&type=script&lang=js&"
import style0 from "./StuCZManage.vue?vue&type=style&index=0&id=d5c1ef48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c1ef48",
  null
  
)

export default component.exports